<template>
	<TableView v-if="showTableView" :col="columns" :getData="getData"/>           
</template>
<script>
import common from '@/assets/js/common.js';
import { mapActions } from 'vuex';

export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  mixins: [common],
  props: ['report_date','report'],
  data(){
  	return {
      showTableView: false,
      res: {},
      columns: (() => {
        const cols = []
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('report', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  created() {
  },
  mounted(){
    this.changeBodyLoading(true);
    let uri = 'reconciliation_balance_report?report_date='+this.report_date+'&report='+this.report;
    this.call_axios(uri).then(res => {
        this.res = res;
        this.columns = [
          { title: 'Date', field: 'date', visible: 'true',thClass: "leftfixed", tdClass: "leftfixed", tdStyle: {padding: "0.8rem !important"}},
        ];
        Object.keys(res.response.data.result[0]).forEach((v) => {
          if(v!='date')
            this.columns.push({ title: v.toUpperCase(), field: v, tdComp: 'Number', 'floatLength': 2, tdStyle: function(row,value){return value>0?{color:'green'}:value<0?{color:'red'}:{}} });
        })
        this.showTableView = true;
        this.changeBodyLoading(false);
    });
  },
  methods: {
    ...mapActions('layout', ['changeBodyLoading']),
    async getData(query, filter) {
      return this.res;
    }
  }
}
</script>
<style>
.header-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  color:#fff;
  padding: 10px 0 0 0;
}
</style>